// src/components/practices/PracticeUnlockCelebration.js
// The "NEW PRACTICE UNLOCKED" moment — shown once, the first time a completed Journey day
// crosses a Practice's unlockDay. A small overlay (fixed, on top of whatever's underneath —
// the Journal arrival screen, in practice), explicitly not another CompletionJourney-weight
// takeover. "Try It" opens the Practice's own intro screen; "Not Now" just dismisses — the user
// is never forced into the Practice itself. See App.js for the seen-state/trigger wiring.
import React from 'react'
import PrimaryButton from '../ui/PrimaryButton'
import './PracticeUnlockCelebration.css'

export default function PracticeUnlockCelebration({ practice, onTryIt, onNotNow }) {
  if (!practice) return null

  return (
    <div className="practice-unlock-screen" data-city="august">
      <div className="practice-unlock">
        <div className="practice-unlock-mark">✦</div>
        <div className="practice-unlock-eyebrow">New Practice Unlocked</div>
        <h2 className="practice-unlock-name">{practice.name}</h2>
        <p className="practice-unlock-body">
          This Practice is now part of your Magic Toolkit. You can return to it anytime.
        </p>

        <PrimaryButton onClick={onTryIt}>
          <span>Try It</span>
          <span>→</span>
        </PrimaryButton>

        <button type="button" className="practice-unlock-not-now" onClick={onNotNow}>
          Not Now
        </button>
      </div>
    </div>
  )
}
